import { gsap } from 'gsap';

document.addEventListener('DOMContentLoaded', () => {
  videoMouseFollow();
});

function videoMouseFollow() {
  const videoFrames = document.querySelectorAll(
    '[data-mouse-follow="true"].aw_video_fullwidth'
  );
  if (!videoFrames) return;

  let i = 0;
  const mm = gsap.matchMedia();

  videoFrames.forEach((videoFrame) => {
    i++;
    const videoContainer = videoFrame.parentNode;
    videoContainer.id = 'abw_video_container_' + i;

    const containerSelector = `#abw_video_container_${i}`;
    const playBtnSelector = `${containerSelector} .aw_moving_video_play_button`;

    if (
      !videoFrame.dataset.videoWithSound.length > 0 ||
      !videoFrame.dataset.videoWithSound
    ) {
      videoContainer.classList.add('aw_muted_video_only');
      console.log(videoContainer);
      return;
    }

    const movingPlayButton = document.createElement('div');

    movingPlayButton.innerHTML = '&#xe921;';
    movingPlayButton.classList.add('aw_moving_video_play_button');
    videoFrame.after(movingPlayButton);

    // gsap.set('.aw_moving_video_play_button', {
    //   xPercent: -50,
    //   yPercent: -50
    // });

    //quickSetter is faster then gesap.set() when in a loop
    const btnSetup = gsap.quickSetter(playBtnSelector, 'css');
    btnSetup({ xPercent: '-50', yPercent: '-50' }); //works!

    var playBtn = document.querySelector(playBtnSelector);
    var pos = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
    var mouse = { x: pos.x, y: pos.y };
    var speed = 0.1;
    var fpms = 60 / 1000;

    var xSet = gsap.quickSetter(playBtn, 'x', 'px');
    var ySet = gsap.quickSetter(playBtn, 'y', 'px');

    videoFrame.addEventListener('mousemove', (e) => {
      mouse.x = e.x;
      mouse.y = e.y;
    });

    mm.add('(min-width: 780px)', () => {
      gsap.ticker.add((time, deltaTime) => {
        var delta = deltaTime * fpms;
        var dt = 1.0 - Math.pow(1.0 - speed, delta);
        pos.x += (mouse.x - pos.x) * dt;
        pos.y += (mouse.y - pos.y) * dt;
        xSet(pos.x);
        ySet(pos.y);
      });
    });

    videoFrame.addEventListener('click', () => {
      if (videoContainer.classList.contains('aw_video_playing')) return;

      if (videoFrame.dataset.source === 'yt') {
        // Iframe and privacy text is handled in video_optin.js
        videoContainer.classList.add('aw_video_wrapper');
        // videoFrame.remove();
      } else {
        videoFrame.src = videoFrame.dataset.videoWithSound;
        videoFrame.controls = true;
        videoFrame.muted = false;
      }

      videoContainer.classList.add('aw_video_playing');
    });
  });

  //special thanks to Blake Bowen for most of the code.
}
